import React, { useState } from "react";
import Header from "../components/header";
import Footer from "../components/footer";
import { Link } from "react-router-dom";
import "./contact.css";

function Contact() {
  // Define a state to manage form submission
  const [fullname, setFullname] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [Subject, setSubject] = useState("");

  const handleFormSubmission = (e) => {
    e.preventDefault(); // Prevent the default form submission behavior

    // Perform any form submission logic here, e.g., send data to a server
    console.log("fullname:", fullname);
    console.log("email:", email);
    console.log("Subject:", Subject);
    console.log("message:", message);

    // Redirect to the desired email format
    const emailFormat = `mailto:support@wealthsystem.net?subject=${encodeURIComponent(
      fullname
    )}(${encodeURIComponent(email)}) : ${encodeURIComponent(
      Subject
    )}&body=${encodeURIComponent(message)}`;

    window.location.href = emailFormat;
  };

  return (
    <div>
      <Header />

      <div className="contact-hero">
        <div className="contact-hero-content container">
          <h1>Contact Us</h1>
          <p>
            <Link to="/" className="contact-breadcrumb-home">
              Home
            </Link>
            <span className="contact-breadcrumb-separator"> / </span>
            <span className="contact-breadcrumb-current">Contact</span>
          </p>
        </div>
      </div>

      <div className="w3-black">
        <div
          className=""
          style={{
            backgroundImage: `url(./home1.jpg)`,
            backgroundPosition: "center",
          }}
        >
          <div
            className="pt-5 "
            style={{ minHeight: "100vh", backgroundColor: "#fff" }}
          >
            <div className="row">
              <div className="col-lg-5 offset-lg-1 text-center">
                <img src="contact.png" style={{ width: "70%" }} />

                <p className="text-center" style={{ color: "black" }}>
                  <a href="mailto:admin@wealthsystem.net">
                    admin@wealthsystem.net
                  </a>{" "}
                  |{" "}
                  <a href="mailto:support@wealthsystem.net">
                    {" "}
                    support@wealthsystem.net
                  </a>
                </p>

                <p className="text-center" style={{ color: "black" }}>
                  Need help? <br />
                  <strong>Reach out to us</strong> anytime via <br /> Mail:
                  <a href="mailto:admin@wealthsystem.net">
                    {" "}
                    admin@wealthsystem.net
                  </a>{" "}
                  Tel:
                  <a href="tel: +2349129949358"> +234 9129949358</a>.{" "}
                </p>

                <p className="text-center" style={{ color: "black" }}>
                  Contact Us <br />
                  <strong className="site-text-color ">
                    Rauxmac Integrated Concepts (CAC No. 3477556)
                  </strong>
                  <br />
                  Suit 1, Ignobis Hotels front offices phase 4 Kubwa Abuja,
                  Nigeria.
                </p>
              </div>

              <div
                className="col-lg-5 p-4 pt-5 "
                style={{
                  borderRadius: "10px",
                  zIndex: "1",
                }}
              >
                <h1
                  className=" text-dark text-center"
                  style={{ fontWeight: "800" }}
                >
                  {" "}
                  Send Us a Message{" "}
                </h1>

                <div
                  className="site-text-color   text-center pb-4"
                  style={{ marginTop: "-5px", fontSize: "20px" }}
                >
                  What can we help you with?
                </div>
                <form onSubmit={handleFormSubmission}>
                  <div className="mb-3">
                    <input
                      placeholder="Name"
                      type="text"
                      className="form-control   bg-white"
                      id="exampleInputEmail1"
                      value={fullname}
                      name="Full Name"
                      onChange={(e) => setFullname(e.target.value)}
                      aria-describedby="fullnameHelp"
                    />
                  </div>

                  <div className="mb-3">
                    <input
                      placeholder="Email Address"
                      type="email"
                      className="form-control  bg-white"
                      id="emailaddress"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </div>

                  <div className="mb-3">
                    <input
                      placeholder="Subject"
                      type="text"
                      className="form-control  bg-white"
                      id="Subject"
                      value={Subject}
                      onChange={(e) => setSubject(e.target.value)}
                    />
                  </div>

                  <div className="mb-3">
                    <textarea
                      placeholder="Enter your message"
                      className="form-control  bg-white"
                      style={{ height: "200px", width: "100%" }}
                      id="message"
                      value={message}
                      onChange={(e) => setMessage(e.target.value)}
                    ></textarea>
                  </div>

                  <button type="submit" className="btn btn-primary  w-100">
                    Submit
                  </button>
                </form>
              </div>
              <div className="col-lg-3  fontFam0  "></div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Contact;
